export default {
    // --------Title--------
    rateInfo: 'Rate Info',
    detailsOfShippingRateCharges: 'Details of shipping rate charges',
    detailsOfShippingRateInformation: 'Details of shipping rate information',
    ruleInfo: 'Rule Info',
    detailsOfShippingRule: 'Details of shipping rule',
    ruleItemsInfo: 'Rule Items Info',
    detailsOfItemInformation: 'Details of item information',
    locationAndAreaSettings: 'Location and Area Settings',
    selectAreaForUpdateThePriceForEachRulesApplication: 'Select area for update the price for each rules application',

    // --------Drawer-------
    changeDefaultMethodsFor: 'Change Default Methods for',
    newAreaFor: 'New Area for ',
    measureMethodRules: 'Measure Method Rules',
    rules: 'Rules',
    Area: 'Area',
    Weight: 'Weight',
    CBM: 'CBM',
    Unit: 'Unit',

    // --------MUI--------
    manageRules: 'Manage Rules',
    manageShippingRates: 'Manage Shipping Rates',
    rateName: 'Rate Name',
    ruleName: 'Rule Name',
    calculationType: 'Calculation Type',
    measureType: 'Measure Type',
    baseAmount: 'Base Amount',
    chargeMethod: 'Charge Method',
    minValue: 'Min Value',
    maxValue: 'Max Value',
    itemRate: 'Item Rate',
    addRule: 'Add Rule',

    empty: 'Empty',
    defaultMeasureMethods: 'Default Measure Methods',
    removeAreaRuleItem: 'Remove Area Rule Item',
    addNewArea: 'Add New Area',
    changeDefault: 'Change Default',
    areYouSureToDeleteThis: 'Are you sure to delete this',
    
};